import { render, staticRenderFns } from "./ReportSingle.vue?vue&type=template&id=6f122c4c&lang=pug&"
import script from "./ReportSingle.vue?vue&type=script&lang=ts&"
export * from "./ReportSingle.vue?vue&type=script&lang=ts&"
import style0 from "./ReportSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports